import { _ as _class_call_check } from "@swc/helpers/_/_class_call_check";
import { _ as _create_class } from "@swc/helpers/_/_create_class";
import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
import { buildCategoryNavigationPath } from "@faire/retailer-shared/categories/navigationPath";
import { CATEGORY_PATH_IDENTIFIER_DELIMITER } from "@faire/retailer-shared/categories/pathIdentifier";
import { ALL_BRANDS_URL_ID, ECO_FRIENDLY_SUBCATEGORY_URL_ID, NEW_ARRIVALS_SUBCATEGORY_URL_ID, NEW_BRANDS_CATEGORY_URL_ID, NEW_PRODUCTS_CATEGORY_URL_ID, PLUS_SIZE_CATEGORY_URL_ID, SHOWROOM_CATEGORY_URL_ID } from "@faire/retailer-shared/categories/urlId";
export var Category = /*#__PURE__*/ function() {
    "use strict";
    function Category(param) {
        var name = param.name, urlId = param.urlId, pathIdentifier = param.pathIdentifier, isProductFirstCategory = param.isProductFirstCategory, subCategory = param.subCategory, uniqueDisplayName = param.uniqueDisplayName;
        _class_call_check(this, Category);
        this.name = name;
        this.urlId = urlId;
        this.pathIdentifier = pathIdentifier;
        this.subCategory = subCategory;
        this.uniqueDisplayName = uniqueDisplayName;
        this.isProductFirstCategory = isProductFirstCategory;
    }
    _create_class(Category, [
        {
            key: "mostSpecificCategory",
            get: function get() {
                var _this_subCategory;
                var _this_subCategory_mostSpecificCategory;
                return (_this_subCategory_mostSpecificCategory = (_this_subCategory = this.subCategory) === null || _this_subCategory === void 0 ? void 0 : _this_subCategory.mostSpecificCategory) !== null && _this_subCategory_mostSpecificCategory !== void 0 ? _this_subCategory_mostSpecificCategory : this;
            }
        },
        {
            key: "mostSpecificName",
            get: function get() {
                var _this_subCategory;
                var _this_subCategory_mostSpecificName;
                return (_this_subCategory_mostSpecificName = (_this_subCategory = this.subCategory) === null || _this_subCategory === void 0 ? void 0 : _this_subCategory.mostSpecificName) !== null && _this_subCategory_mostSpecificName !== void 0 ? _this_subCategory_mostSpecificName : this.name;
            }
        },
        {
            key: "mostSpecificUniqueDisplayName",
            get: function get() {
                var _this_subCategory;
                var _this_subCategory_mostSpecificUniqueDisplayName;
                return (_this_subCategory_mostSpecificUniqueDisplayName = (_this_subCategory = this.subCategory) === null || _this_subCategory === void 0 ? void 0 : _this_subCategory.mostSpecificUniqueDisplayName) !== null && _this_subCategory_mostSpecificUniqueDisplayName !== void 0 ? _this_subCategory_mostSpecificUniqueDisplayName : this.uniqueDisplayName;
            }
        },
        {
            key: "mostSpecificPathIdentifier",
            get: function get() {
                var _this_subCategory;
                var _this_subCategory_mostSpecificPathIdentifier;
                return (_this_subCategory_mostSpecificPathIdentifier = (_this_subCategory = this.subCategory) === null || _this_subCategory === void 0 ? void 0 : _this_subCategory.mostSpecificPathIdentifier) !== null && _this_subCategory_mostSpecificPathIdentifier !== void 0 ? _this_subCategory_mostSpecificPathIdentifier : this.pathIdentifier;
            }
        },
        {
            key: "mostSpecificLevel",
            get: // TODO: This should leverage the tree_level property from the backend instead of parsing
            // the path identifier
            function get() {
                var _this_mostSpecificPathIdentifier;
                var _this_mostSpecificPathIdentifier_split;
                var categories = (_this_mostSpecificPathIdentifier_split = (_this_mostSpecificPathIdentifier = this.mostSpecificPathIdentifier) === null || _this_mostSpecificPathIdentifier === void 0 ? void 0 : _this_mostSpecificPathIdentifier.split(CATEGORY_PATH_IDENTIFIER_DELIMITER)) !== null && _this_mostSpecificPathIdentifier_split !== void 0 ? _this_mostSpecificPathIdentifier_split : [];
                return categories.length;
            }
        },
        {
            key: "urlIds",
            get: function get() {
                var _this_subCategory;
                var _this_subCategory_urlIds;
                return [
                    this.urlId
                ].concat(_to_consumable_array((_this_subCategory_urlIds = (_this_subCategory = this.subCategory) === null || _this_subCategory === void 0 ? void 0 : _this_subCategory.urlIds) !== null && _this_subCategory_urlIds !== void 0 ? _this_subCategory_urlIds : []));
            }
        },
        {
            key: "urlIdStrings",
            get: function get() {
                return this.urlIds.map(function(urlId) {
                    return urlId.id;
                });
            }
        },
        {
            key: "navigationPath",
            get: function get() {
                return buildCategoryNavigationPath(this.urlIdStrings);
            }
        },
        {
            key: "isSuppliersPageCategoryValid",
            get: function get() {
                // these categories do not have a suppliers page
                return !(this.isNewProducts || this.isNewBrandsC1 || this.isNewArrivalsSubCategory);
            }
        },
        {
            key: "isPrimaryCategory",
            get: function get() {
                return !this.subCategory;
            }
        },
        {
            key: "isAllBrands",
            get: function get() {
                return this.urlId.id === ALL_BRANDS_URL_ID;
            }
        },
        {
            key: "isPlusSize",
            get: function get() {
                return this.urlId.id === PLUS_SIZE_CATEGORY_URL_ID;
            }
        },
        {
            key: "isNewProducts",
            get: function get() {
                return this.isNewProductsSubCategory || this.isNewProductsC1;
            }
        },
        {
            key: "isNewProductsSubCategory",
            get: function get() {
                var _this_subCategory;
                var _ref;
                // return true if the url is /category/{c1CategoryUrlId}/subcategory[/{c2CategoryUrlId}]/New Products
                return (_ref = ((_this_subCategory = this.subCategory) === null || _this_subCategory === void 0 ? void 0 : _this_subCategory.isNewProducts) && this.urlId.id !== NEW_PRODUCTS_CATEGORY_URL_ID) !== null && _ref !== void 0 ? _ref : false;
            }
        },
        {
            key: "isNewProductsC1",
            get: function get() {
                // return true if the url is
                // /category/new products[/subcategory/{c2categoryUrlId}/[/{c3CategoryUrlId}]]
                return this.urlId.id === NEW_PRODUCTS_CATEGORY_URL_ID;
            }
        },
        {
            key: "isNewBrandsC1",
            get: function get() {
                return this.urlId.id === NEW_BRANDS_CATEGORY_URL_ID;
            }
        },
        {
            key: "isNewArrivalsSubCategory",
            get: function get() {
                var _this_subCategory;
                return ((_this_subCategory = this.subCategory) === null || _this_subCategory === void 0 ? void 0 : _this_subCategory.isNewArrivalsSubCategory) || this.urlId.id === NEW_ARRIVALS_SUBCATEGORY_URL_ID;
            }
        },
        {
            key: "isEcoFriendlySubCategory",
            get: function get() {
                var _this_subCategory;
                return ((_this_subCategory = this.subCategory) === null || _this_subCategory === void 0 ? void 0 : _this_subCategory.isEcoFriendlySubCategory) || this.urlId.id === ECO_FRIENDLY_SUBCATEGORY_URL_ID;
            }
        },
        {
            key: "isSubcategoryOfShowroomC1",
            get: function get() {
                return this.urlId.id === SHOWROOM_CATEGORY_URL_ID;
            }
        }
    ]);
    return Category;
}();
